<template>
  <v-expansion-panel expand v-model="expand">
    <v-expansion-panel-content v-for="account in items" :key="account.account_id">
      <div slot="header">
        <div style="display: flex" class="align-center pr-4">
          <v-icon
            v-html="'mdi-checkbox-blank-circle'"
            small
            :color="getStatusColor(account.success)"
            class="mr-4"
          />
          <span class="body-2">{{ account.account_id.toUpperCase() }}</span class="body-2">
          <div class="spacer"></div>
          <div v-if="!account.error && account.totals.available_USD !== false" :class="[
            'd-inline-block',
            'text-xs-right'
          ]">
            {{ account.totals.available_USD | dollar }}
          </div>
          <div v-if="!account.error && account.totals.balance_USD !== false" :class="[
            'd-inline-block',
            'text-xs-right',
            account.incorrect ? 'red--text' : undefined
          ]" style="width: 130px">
            {{ account.totals.balance_USD | dollar }}
          </div>
        </div>
      </div>
      <div class="pa-3 grey lighten-4">
        <v-layout row wrap>
          <template v-if="!account.error">
            <v-flex v-if="!account.balances.length" d-flex xs12 class="text-xs-center">
              <span class="grey--text">
                <i>Empty</i>
              </span>
            </v-flex>
            <v-flex v-else v-for="balance in account.balances" :key="balance.currency" d-flex xs12 sm6 md4>
              <v-card class="elevation-4 ma-2 mb-3">
                <v-card-title primary-title>
                  <h1 class="primary--text">{{ balance.currency }}</h1>
                </v-card-title>
                <v-card-text class="pt-0">
                  <div>
                    <span class="grey--text body-2">Available: </span>
                    <span>{{ balance.available_USD | dollar }} ({{ balance.available }})</span>
                  </div>
                  <div>
                    <span class="grey--text body-2">Balance: </span>
                    <span>{{ balance.balance_USD | dollar }} ({{ balance.balance }})</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </template>
          <v-flex v-if="account.error" d-flex xs12>
            <v-alert outline color="error" icon="warning" :value="true" class="ma-2 white">
              {{ account.error }}
            </v-alert>
          </v-flex>
        </v-layout>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true }
  },
  data () {
    return {
      expand: this.items.map(account => {
        return account.expand || !account.success || this.items.length === 1
      })
    }
  },
  methods: {
    getStatusColor (value) {
      if (value === null) return null
      return value ? 'success' : 'error'
    }
  }
}
</script>
